if (!customElements.get('faq-section')) {
    customElements.define('faq-section', class FaqSection extends HTMLElement {
        constructor() {
            super();
            this.faqHeading = this.querySelectorAll('.faq__item-heading');
            this.initEvents();
        }

        initEvents() {
            this.faqHeading.forEach(heading => heading.onclick = () => this.onHeadingOpen(heading));
        }

        onHeadingOpen(heading) {
            if (heading.closest('.faq__item').classList.contains('is_open')) {
                heading.closest('.faq__item').classList.remove('is_open');
            } else {
                this.faqHeading.forEach((heading) => {
                    heading.closest('.faq__item').classList.remove('is_open');
                });
                heading.closest('.faq__item').classList.add('is_open');
            }
        }
    });
}